module.exports = __webpack_public_path__ + "media/images/flags/bb-509fd847d6d39ef34e36fa74da62f047.svg";